import formatMessage from './i18n/formatMessage';

const operationTypeString = [
  {
    label: formatMessage('formaAplicacao.descricao'),
    field: 'dsFormaAplicacao',
    type: 'string'
  },
  {
    label: formatMessage('formaAplicacao.situacao'),
    field: 'stFormaAplicacao',
    type: 'enum',
    options: [
      {
        label: formatMessage('formaAplicacao.ativo'),
        field: 'Ativo',
        value: '1'
      },
      {
        label: formatMessage('formaAplicacao.inativo'),
        field: 'Inativo',
        value: '0'
      }
    ]
  }
];

const head = [
  {
    field: 'dsFormaAplicacao',
    headerName: formatMessage('formaAplicacao.descricao'),
    col: 6
  },
  {
    valueGetter: args =>
      [formatMessage('formaAplicacao.inativo'), formatMessage('formaAplicacao.ativo')][
        args.node.data.stFormaAplicacao
      ],
    headerName: formatMessage('formaAplicacao.situacao'),
    col: 6
  }
];

export { head, operationTypeString };
